import React from "react";
import "./SofaRepair.css";

import {
  FaCouch,
  FaTools,
  FaCheckCircle,
  FaArrowRight,
  FaWhatsapp,
  FaPhone,
  FaHammer,
  FaShieldAlt,
  FaStar,
  FaWrench,
} from "react-icons/fa";

import Footer from "../footer/Footer";
import Location from "../location/Location";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";

export default function SofaRepair() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const openWhatsApp = (message) => {
    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const services = [
    {
      icon: <FaTools />,
      number: "01",
      title: "Sofa Frame Repair",
      text: "Broken or weak sofa frames are repaired and strengthened by experienced craftsmen.",
    },
    {
      icon: <FaTools />,
      number: "02",
      title: "Spring Repair",
      text: "Sagging and damaged springs are repaired or replaced to restore proper support.",
    },
    {
      icon: <FaCouch />,
      number: "03",
      title: "Foam Replacement",
      text: "Replace old and compressed foam with comfortable, high-density foam.",
    },
    {
      icon: <FaHammer />,
      number: "04",
      title: "Sofa Restoration",
      text: "Complete restoration service for old, damaged and worn-out sofas.",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Inspection",
      text: "Our team checks the sofa frame, springs, foam and upholstery condition.",
    },
    {
      number: "02",
      title: "Estimate",
      text: "We explain the required repair work and provide a clear estimate.",
    },
    {
      number: "03",
      title: "Repair",
      text: "Our craftsmen complete the repair using suitable materials and techniques.",
    },
    {
      number: "04",
      title: "Final Check",
      text: "Every repaired sofa is checked carefully before completion.",
    },
  ];

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="rk-repair-hero">
        <div className="rk-repair-hero-shape"></div>

        <div className="container">
          <div className="row align-items-center g-5">

            {/* CONTENT */}
            <div className="col-12 col-lg-6">
              <div className="rk-repair-content">

                <div className="rk-repair-eyebrow">
                  <span></span>
                  PROFESSIONAL SOFA REPAIR
                </div>

                <h1>
                  Restore Your Sofa.
                  <br />
                  <em>Restore Your Comfort.</em>
                </h1>

                <p className="rk-repair-intro">
                  Expert sofa repair services in Noida for frames, springs,
                  foam, legs and complete sofa restoration. We bring old and
                  damaged sofas back to comfortable, usable condition.
                </p>

                <div className="rk-repair-actions">

                  <a
                    href={`tel:${PHONE}`}
                    className="rk-repair-call"
                  >
                    <FaPhone />

                    <span>
                      <small>CALL OUR EXPERT</small>
                      Call Now
                    </span>
                  </a>

                  <button
                    type="button"
                    className="rk-repair-whatsapp"
                    onClick={() =>
                      openWhatsApp(
                        "Hi RK Sofa Works, I need sofa repair service in Noida."
                      )
                    }
                  >
                    <FaWhatsapp />
                    <span>WhatsApp Us</span>
                    <FaArrowRight />
                  </button>

                </div>

                <div className="rk-repair-trust">

                  <div>
                    <FaCheckCircle />
                    <span>Experienced Craftsmen</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Doorstep Service</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Quality Materials</span>
                  </div>

                </div>

              </div>
            </div>

            {/* IMAGE */}
            <div className="col-12 col-lg-6">

              <div className="rk-repair-image-box">

                <div className="rk-repair-image-frame">

                  <img
                    src="/img/sofa_repair.png"
                    alt="Professional Sofa Repair Service in Noida"
                  />

                  <div className="rk-repair-image-gradient"></div>

                </div>

                {/* EXPERIENCE CARD */}
                <div className="rk-repair-experience">

                  <div className="rk-repair-experience-icon">
                    <FaShieldAlt />
                  </div>

                  <div>
                    <strong>Trusted Service</strong>
                    <span>Quality Sofa Repair</span>
                  </div>

                </div>

                {/* RATING */}
                <div className="rk-repair-rating">

                  <div className="rk-stars">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>

                  <strong>Professional Sofa Care</strong>
                  <span>Noida & NCR</span>

                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= INTRO STATS ================= */}
      <section className="rk-repair-stats">

        <div className="container">

          <div className="rk-repair-stats-inner">

            <div className="rk-repair-stat">
              <strong>18+</strong>
              <span>Years Experience</span>
            </div>

            <div className="rk-stat-divider"></div>

            <div className="rk-repair-stat">
              <strong>2500+</strong>
              <span>Sofas Repaired</span>
            </div>

            <div className="rk-stat-divider"></div>

            <div className="rk-repair-stat">
              <strong>100%</strong>
              <span>Attention to Detail</span>
            </div>

            <div className="rk-stat-divider"></div>

            <div className="rk-repair-stat">
              <strong>Noida</strong>
              <span>Doorstep Service</span>
            </div>

          </div>

        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="rk-repair-services">

        <div className="container">

          <div className="rk-section-heading">

            <span>WHAT WE REPAIR</span>

            <h2>
              Complete Sofa Repair
              <br />
              <em>Solutions</em>
            </h2>

            <p>
              From internal structure to seating comfort, we handle the
              essential repair work your sofa needs.
            </p>

          </div>

          <div className="row g-4">

            {services.map((item) => (
              <div
                className="col-12 col-sm-6 col-lg-3"
                key={item.number}
              >

                <article className="rk-repair-service-card">

                  <div className="rk-service-top">

                    <span>{item.number}</span>

                    <div className="rk-service-icon">
                      {item.icon}
                    </div>

                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                  <div className="rk-service-line"></div>

                  <button
                    type="button"
                    onClick={() =>
                      openWhatsApp(
                        `Hi RK Sofa Works, I need ${item.title.toLowerCase()} service for my sofa.`
                      )
                    }
                  >
                    <span>Enquire Now</span>
                    <FaArrowRight />
                  </button>

                </article>

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= WHY US ================= */}
      <section className="rk-repair-quality">

        <div className="container">

          <div className="row align-items-center g-5">

            {/* IMAGE */}
            <div className="col-12 col-lg-5">

              <div className="rk-quality-image">

                <img
                  src="/img/sofa_repair_1.png"
                  alt="Sofa restoration work"
                />

                <div className="rk-quality-label">

                  <FaWrench />

                  <span>
                    Craftsmanship
                    <br />
                    You Can Trust
                  </span>

                </div>

              </div>

            </div>

            {/* CONTENT */}
            <div className="col-12 col-lg-7">

              <div className="rk-quality-content">

                <span className="rk-small-heading">
                  WHY CHOOSE RK SOFA WORKS
                </span>

                <h2>
                  Repair Instead of
                  <br />
                  <em>Replacing.</em>
                </h2>

                <p>
                  A good-quality sofa can often be restored instead of being
                  replaced. Our repair service focuses on the actual problem
                  — whether it is the frame, spring system, foam or upholstery.
                </p>

                <div className="rk-quality-list">

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Experienced Craftsmanship</strong>
                      <span>
                        Careful repair by skilled sofa craftsmen.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Quality Materials</strong>
                      <span>
                        Suitable materials selected according to the repair.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Practical Solutions</strong>
                      <span>
                        We focus on repairing the actual issue properly.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Doorstep Convenience</strong>
                      <span>
                        Service available across Noida and nearby areas.
                      </span>
                    </div>
                  </div>

                </div>

                <button
                  type="button"
                  className="rk-quality-btn"
                  onClick={() =>
                    openWhatsApp(
                      "Hi RK Sofa Works, I want to get my sofa inspected for repair."
                    )
                  }
                >
                  <span>Get Sofa Inspection</span>
                  <FaArrowRight />
                </button>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="rk-repair-process">

        <div className="container">

          <div className="rk-section-heading">

            <span>HOW IT WORKS</span>

            <h2>
              Simple Repair
              <br />
              <em>Process</em>
            </h2>

            <p>
              A straightforward process from sofa inspection to final repair.
            </p>

          </div>

          <div className="rk-process-grid">

            {process.map((item, index) => (
              <div
                className="rk-process-item"
                key={item.number}
              >

                <div className="rk-process-number">
                  {item.number}
                </div>

                <div className="rk-process-content">

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                </div>

                {index !== process.length - 1 && (
                  <div className="rk-process-arrow">
                    <FaArrowRight />
                  </div>
                )}

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="rk-repair-cta">

        <div className="container">

          <div className="rk-repair-cta-inner">

            <div>

              <span>
                YOUR SOFA DESERVES A SECOND LIFE
              </span>

              <h2>
                Is Your Sofa Damaged,
                <br />
                Sagging or Uncomfortable?
              </h2>

              <p>
                Send us a few photos of your sofa and our team will guide
                you about the required repair.
              </p>

            </div>

            <button
              type="button"
              onClick={() =>
                openWhatsApp(
                  "Hi RK Sofa Works, I want to repair my sofa. I am sharing photos for an estimate."
                )
              }
            >
              <FaWhatsapp />
              <span>Send Sofa Photos</span>
              <FaArrowRight />
            </button>

          </div>

        </div>
      </section>

      <Offer />
      <Location />
      <Footer />
    </>
  );
}